import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import styles from './ThankYou.module.css';
import { DesktopView } from './desktop/ChooseYourPlan.desktop';
import { MobileView } from './mobile/ChooseYourPlan.mobile';
import { useAppSelector } from '../../../store/hooks';

export const ChooseYourPlan = (): JSX.Element => {
  // Redux Hooks

  return (
    <React.Fragment>
      {isMobileOnly ? <MobileView /> : <DesktopView />}
    </React.Fragment>
  );
};
